import React, { useEffect, useState } from 'react';

export const parseIST = (s) => {
  const m = (s || '').trim().match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{1,2}):(\d{2}))?$/);
  if (!m) return null;
  const t = Date.parse(`${m[1]}-${m[2]}-${m[3]}T${(m[4] || '00').padStart(2, '0')}:${m[5] || '00'}:00+05:30`);
  return Number.isNaN(t) ? null : t;
};

const UNITS = [['Days', 86400000], ['Hours', 3600000], ['Minutes', 60000], ['Seconds', 1000]];

export default function Countdown({ at, label, accent, testid }) {
  const target = parseIST(at);
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);
  if (!target || target <= now) return null;
  let left = target - now;
  return (
    <div className="mb-8 rounded-2xl border border-white/15 bg-white/5 p-5 md:p-6 text-white" data-testid={testid}>
      <p className="eyebrow mb-4" style={{ color: accent }}>{label}</p>
      <div className="flex gap-3 md:gap-6">
        {UNITS.map(([name, ms]) => {
          const v = Math.floor(left / ms);
          left -= v * ms;
          return (
            <div key={name} className="min-w-[64px] md:min-w-[96px]" data-testid={`${testid}-${name.toLowerCase()}`}>
              <p className="font-display text-3xl md:text-5xl tabular-nums">{String(v).padStart(2, '0')}</p>
              <p className="text-xs uppercase tracking-wide text-white/60 mt-1">{name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}
